export const TASKS_KEY = 'tasks'
export const INFINITE_TASKS_KEY = 'tasks-infinite'
export const ALGOLIA_TASKS_KEY = 'algolia-tasks'
export const ALGOLIA_FEED_KEY = 'algolia-feed'
export const TASKS_BY_IDS_KEY = 'tasks-by-ids'
export const CARE_REASONS_KEY = 'careReasons'
export const INFINITE_CARE_REASONS_KEY = 'care-reasons-infinite'
export const ALGOLIA_CARE_REASONS_KEY = 'algolia-care-reasons'
export const CARE_REASONS_BY_IDS_KEY = 'care-reasons-by-ids'
export const MEMBERS_KEY = 'members'
export const INFINITE_MEMBERS_KEY = 'members-infinite'
export const MEMBERS_BY_IDS_KEY = 'members-by-ids'
export const MEMBERS_SEARCH_KEY = 'members-search'
export const ALGOLIA_MEMBERS_KEY = 'algolia-members'
export const GOALS_KEY = 'goals'
export const INFINITE_GOALS_KEY = 'goals-infinite'
export const GROUPS_KEY = 'groups'
export const INTEGRATIONS_KEY = 'integrations'
export const TASK_TEMPLATES_KEY = 'task-templates'
export const CARE_REASON_TEMPLATES_KEY = 'care-reason-templates'
export const BATCH_OPERATIONS_KEY = 'batch-operations'
export const BATCH_OPERATION_ITEMS_KEY = 'batch-operation-items'
